import React, { Component } from 'react';
import './App.css';
import Main from "./components/main"

class App extends Component {
	render(){
		return <Main />
	}
}

export default App
